  import { Helmet } from 'react-helmet';
  import {
    Box,
    Container,
    Button,
    TextField,
    CardContent,
    OutlinedInput,
    Checkbox,
    ListItemText,
    Breadcrumbs
  } from '@material-ui/core';
  import ChevronLeft from '@material-ui/icons/ChevronLeft';
  import { Form, Link, useNavigate, useParams } from 'react-router-dom';
  import { useGet, usePost, usePut } from "../../API/request";
  import React, { useEffect, useState } from "react";
  import { BallTriangle } from "react-loader-spinner";
  import FormControl from "@material-ui/core/FormControl";
  import InputLabel from "@material-ui/core/InputLabel";
  import Select from "@material-ui/core/Select";
  import MenuItem from "@material-ui/core/MenuItem";
  import Card from "@material-ui/core/Card";
  import CardHeader from "@material-ui/core/CardHeader";
  import Divider from "@material-ui/core/Divider";
  import Alert from "@material-ui/core/Alert";

  const PriceSectionAdd = () => {
    const navigate = useNavigate();
    const postU = usePost();
    const getU = useGet();
    const putU = usePut();
    const { id } = useParams();
    
    const [ uploadedPreview,setUploadedPreview] = useState('/static/images/defphoto.jpg');
    const [isLoaded, setIsLoaded] = useState(true);
    const [values, setValues] = useState({
      value: "",
      city_id: [],
      parent_category: id,
      level: +!!+id,
      description: "",
      img: null
    });

    const [errors, setErrors] = useState({
      value: false,
      city_id: false,
      img: false,
    });

    const [cities, setCities] = useState([]);
    const [choosenCities, setChoosenCities] = useState([]);
    const [isShowLoader, setIsShowLoader] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const [alert, setAlert] = useState({
      txt: '',
      isVisible: false,
      type: 'error'
    });

    const handleChange = (event) => {
      setValues({
        ...values,
        [event.target.name]: event.target.value
      });
      setErrors({
        ...errors,
        [event.target.name]: false
      });
    };

    const handleChangeCity = (event) => {
      const value = event.target.value;
      setChoosenCities(value);
      setValues({
        ...values,
        city_id: value?.map((el) => cities?.find(elem => elem.name === el)?.id),
      });
      setErrors({
        ...errors,
        city_id: false
      });
    };

    const showAlert = (type, text) => {
      setAlert({
        txt: text,
        type,
        isVisible: true,
      });

      setTimeout(() => {
        setAlert({
          txt: text,
          type,
          isVisible: false,
        });
        setSubmitDisabled(false);
      }, 1400);
    };

    const validate = () => {
      let validComplete = true;
      let formErrors = { ...errors };

      if (!values.value) {
        validComplete = false;
        formErrors.value = true;
        showAlert('error', "Название раздела обязательно");
      }

      if (!values.city_id.length) {
        validComplete = false;
        formErrors.city_id = true;
        showAlert('error', "Выберите хотя бы один город");
      }

      if (!values.img) {
        validComplete = false;
        formErrors.img = true;
        showAlert('error', "Загрузите изображение");
      }

      setErrors(formErrors);
      return validComplete;
    };

    const clearForm = () => {
      setValues({
        value: "",
        city_id: [],
        img: null
      });
      setUploadedPreview('/static/images/defphoto.jpg');
    };

    const imageUploaded = async (event) => {
      const file = event.target.files[0];
      if (!file) return;
    
      if (!file.type.match('image.*')) {
        showAlert('error', 'Выберите файл изображения');
        return;
      }
    
      setValues({
        ...values,
        img: file 
      });
      setUploadedPreview(URL.createObjectURL(file)); 
    };
    const submit = async () => {
      if (!validate()) return;

      setIsShowLoader(true);
      setSubmitDisabled(true);

      const formData = new FormData();
      formData.append("value", values.value);
      formData.append("img", values.img); 
      formData.append("city_id", values.city_id); 
      console.log(values);
      
      try {

        const resp = await postU('price/admin/section', formData);
          
        if (resp.status === 'success') {
          showAlert('success', 'Раздел успешно добавлен');
          clearForm();
        } else {
          showAlert('error', resp.message || 'Ошибка при сохранении');
        }
      } catch (err) {
        showAlert('error', 'Ошибка сервера');
      } finally {
        setIsShowLoader(false);
        setSubmitDisabled(false);
      }
    };

    useEffect(() => {
      const loadCities = async () => {
        setIsLoaded(true);
        try {
          const resp = await getU('city');
          if (resp.status === 'success') {
            setCities(resp.data.city);
          }
        } catch (error) {
          showAlert('error', 'Ошибка при загрузке городов');
        } finally {
          setIsLoaded(false);
        }
      };

      loadCities();

      return () => {
        if (uploadedPreview.startsWith('blob:')) {
          URL.revokeObjectURL(uploadedPreview);
        }
      };
    }, []);

    if (isLoaded) {
      return (
        <div className="loader">
          <BallTriangle
            height="100"
            width="100"
            color='grey'
            ariaLabel='loading'
          />
        </div>
      );
    }

    return (
      <>
        <Helmet>
          <title>Создание нового раздела</title>
        </Helmet>
        <Box className="headerWrapper">
          <Box className="headerTitle">
            <Button startIcon={<ChevronLeft />} onClick={() => navigate(-1)}>
              Назад
            </Button>
            Прайс
          </Box>
          <Breadcrumbs aria-label="breadcrumb" style={{ fontSize: 14 }}>
            <Link underline="hover" color="inherit" to="/app/price-sections">
              Разделы
            </Link>
            <p>Добавление раздела</p>
          </Breadcrumbs>
        </Box>
      <Box sx={{ backgroundColor: 'background.default', minHeight: '100%' }}>
          <Container maxWidth={false}>
            <Box sx={{ pt: 2 }}>
              <form>
                <Card>
                  <CardHeader title="Добавление нового раздела" />
                  <Divider />
                  <Box sx={{ paddingBottom: 1 }}>
                    <Card>
                      <CardHeader title="Изображение раздела" />
                      <Divider />
                      <CardContent sx={{ position: 'relative' }}>
                        <div className="itemWrapper">
                          <div className="container">
                            <input 
                              accept="image/*" 
                              type="file" 
                              style={{ display: 'none' }}
                              id="image-upload"
                              name="img"
                              onChange={imageUploaded}
                            />
                            <label htmlFor="image-upload">
                              <img src={uploadedPreview} className="itemImg" alt="Превью" />
                              <div className="middle" />
                            </label>
                          </div>
                          <div className="help-text">
                            Поддерживаемые форматы: .png, .jpg, .jpeg, .svg, .webp
                          </div>
                        </div>
                      </CardContent>
                      <Divider />
                    </Card>
                  </Box>
                  <CardContent sx={{ position: 'relative' }}>
                    <TextField
                      fullWidth
                      label="Название раздела*"
                      margin="normal"
                      name="value"
                      onChange={handleChange}
                      type="text"
                      value={values.value}
                      variant="outlined"
                      error={errors.value}
                    />
                    <FormControl fullWidth sx={{ mt: 2, mb: 1 }} error={errors.city_id}>
                      <InputLabel id="cities-label">Города*</InputLabel>
                      <Select
                        labelId="cities-label"
                        label="Города*"
                        name="city_id"
                        multiple
                        value={choosenCities}
                        onChange={handleChangeCity}
                        input={<OutlinedInput label="Города*" />}
                        renderValue={(selected) => selected.join(', ')}
                      >
                        {cities?.map((city) => (
                          <MenuItem key={city.id} value={city.name}>
                            <Checkbox checked={choosenCities.includes(city.name)} />
                            <ListItemText primary={city.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Alert 
                      severity={alert.type}
                      style={{ display: alert.isVisible ? 'flex' : 'none' }}
                    >
                      {alert.txt}
                    </Alert>
                  </CardContent>
                  <Divider />
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={submit}
                      disabled={submitDisabled}
                    >
                      Добавить
                    </Button>
                  </Box>
                </Card>
              </form>
            </Box>
          </Container>
        </Box>
      </>
    );
  };

  export default PriceSectionAdd;